// Códigos telefónicos de país, copiados de la tabla ct_countries de WAPP
// (international_phone_prefix) el 2026-09-11. El id coincide con ct_countries,
// así que el país del plantel (campus.company.country_id) se resuelve directo.
// Se mantiene local para no depender de la forma del catálogo en memoria.
export interface PhoneCountry { id: number; name: string; prefix: string }

export const US_COUNTRY_ID = 66

export const PHONE_COUNTRIES: PhoneCountry[] = [
	{id: 4, name: "Afganistán", prefix: "93"},
	{id: 5, name: "Albania", prefix: "355"},
	{id: 6, name: "Alemania", prefix: "49"},
	{id: 7, name: "Andorra", prefix: "376"},
	{id: 8, name: "Angola", prefix: "244"},
	{id: 9, name: "Antigua y Barbuda", prefix: "1268"},
	{id: 10, name: "Arabia Saudita", prefix: "966"},
	{id: 11, name: "Argelia", prefix: "213"},
	{id: 12, name: "Argentina", prefix: "54"},
	{id: 13, name: "Armenia", prefix: "374"},
	{id: 14, name: "Australia", prefix: "61"},
	{id: 15, name: "Austria", prefix: "43"},
	{id: 16, name: "Azerbaiyán", prefix: "994"},
	{id: 17, name: "Bahamas", prefix: "1242"},
	{id: 18, name: "Bangladés", prefix: "880"},
	{id: 19, name: "Barbados", prefix: "1246"},
	{id: 20, name: "Baréin", prefix: "973"},
	{id: 22, name: "Belice", prefix: "501"},
	{id: 23, name: "Benín", prefix: "229"},
	{id: 24, name: "Bielorrusia", prefix: "375"},
	{id: 26, name: "Bolivia", prefix: "501"},
	{id: 27, name: "Bosnia-Herzegovina", prefix: "387"},
	{id: 28, name: "Botsuana", prefix: "267"},
	{id: 3, name: "Brazil", prefix: "55"},
	{id: 29, name: "Brunéi", prefix: "673"},
	{id: 30, name: "Bulgaria", prefix: "359"},
	{id: 31, name: "Burkina Faso", prefix: "226"},
	{id: 32, name: "Burundi", prefix: "257"},
	{id: 33, name: "Bután", prefix: "975"},
	{id: 21, name: "Bélgica", prefix: "32"},
	{id: 34, name: "Cabo Verde", prefix: "238"},
	{id: 35, name: "Camboya", prefix: "855"},
	{id: 36, name: "Camerún", prefix: "237"},
	{id: 37, name: "Canadá", prefix: "1"},
	{id: 38, name: "Catar", prefix: "974"},
	{id: 40, name: "Chad", prefix: "235"},
	{id: 42, name: "Chile", prefix: "56"},
	{id: 43, name: "China", prefix: "86"},
	{id: 44, name: "Chipre", prefix: "357"},
	{id: 189, name: "Ciudad del Vaticano", prefix: "379"},
	{id: 45, name: "Colombia", prefix: "57"},
	{id: 46, name: "Comoras", prefix: "269"},
	{id: 49, name: "Corea del Norte", prefix: "850"},
	{id: 50, name: "Corea del Sur", prefix: "82"},
	{id: 52, name: "Costa Rica", prefix: "506"},
	{id: 51, name: "Costa de Marfil", prefix: "225"},
	{id: 53, name: "Croacia", prefix: "385"},
	{id: 54, name: "Cuba", prefix: "53"},
	{id: 55, name: "Dinamarca", prefix: "45"},
	{id: 56, name: "Dominica", prefix: "1767"},
	{id: 58, name: "Ecuador", prefix: "593"},
	{id: 59, name: "Egipto", prefix: "20"},
	{id: 60, name: "El Salvador", prefix: "503"},
	{id: 61, name: "Emiratos Árabes Unidos", prefix: "971"},
	{id: 62, name: "Eritrea", prefix: "291"},
	{id: 63, name: "Eslovaquia", prefix: "421"},
	{id: 64, name: "Eslovenia", prefix: "386"},
	{id: 65, name: "España", prefix: "34"},
	{id: 66, name: "Estados Unidos", prefix: "1"},
	{id: 67, name: "Estonia", prefix: "372"},
	{id: 68, name: "Etiopía", prefix: "251"},
	{id: 69, name: "Filipinas", prefix: "63"},
	{id: 70, name: "Finlandia", prefix: "358"},
	{id: 71, name: "Fiyi", prefix: "679"},
	{id: 72, name: "Francia", prefix: "33"},
	{id: 73, name: "Gabón", prefix: "241"},
	{id: 74, name: "Gambia", prefix: "220"},
	{id: 75, name: "Georgia", prefix: "995"},
	{id: 76, name: "Ghana", prefix: "233"},
	{id: 77, name: "Granada", prefix: "1473"},
	{id: 78, name: "Grecia", prefix: "30"},
	{id: 79, name: "Guatemala", prefix: "502"},
	{id: 80, name: "Guinea", prefix: "224"},
	{id: 82, name: "Guinea Ecuatorial", prefix: "240"},
	{id: 81, name: "Guinea-Bisáu", prefix: "245"},
	{id: 83, name: "Guyana", prefix: "592"},
	{id: 84, name: "Haití", prefix: "509"},
	{id: 2, name: "Honduras", prefix: "504"},
	{id: 85, name: "Hungría", prefix: "36"},
	{id: 86, name: "India", prefix: "91"},
	{id: 87, name: "Indonesia", prefix: "62"},
	{id: 88, name: "Irak", prefix: "964"},
	{id: 90, name: "Irlanda", prefix: "353"},
	{id: 89, name: "Irán", prefix: "98"},
	{id: 91, name: "Islandia", prefix: "354"},
	{id: 119, name: "Islas Marshall", prefix: "692"},
	{id: 151, name: "Islas Salomón", prefix: "677"},
	{id: 92, name: "Israel", prefix: "972"},
	{id: 93, name: "Italia", prefix: "39"},
	{id: 94, name: "Jamaica", prefix: "1876"},
	{id: 95, name: "Japón", prefix: "81"},
	{id: 96, name: "Jordania", prefix: "962"},
	{id: 97, name: "Kazajistán", prefix: "7"},
	{id: 98, name: "Kenia", prefix: "254"},
	{id: 99, name: "Kirguistán", prefix: "996"},
	{id: 100, name: "Kiribati", prefix: "686"},
	{id: 101, name: "Kuwait", prefix: "965"},
	{id: 102, name: "Laos", prefix: "856"},
	{id: 103, name: "Lesoto", prefix: "266"},
	{id: 104, name: "Letonia", prefix: "371"},
	{id: 106, name: "Liberia", prefix: "231"},
	{id: 107, name: "Libia", prefix: "218"},
	{id: 108, name: "Liechtenstein", prefix: "423"},
	{id: 109, name: "Lituania", prefix: "370"},
	{id: 110, name: "Luxemburgo", prefix: "352"},
	{id: 105, name: "Líbano", prefix: "961"},
	{id: 111, name: "Macedonia del Norte", prefix: "389"},
	{id: 112, name: "Madagascar", prefix: "261"},
	{id: 113, name: "Malasia", prefix: "60"},
	{id: 114, name: "Malaui", prefix: "265"},
	{id: 115, name: "Maldivas", prefix: "960"},
	{id: 116, name: "Mali", prefix: "223"},
	{id: 117, name: "Malta", prefix: "356"},
	{id: 118, name: "Marruecos", prefix: "212"},
	{id: 120, name: "Mauricio", prefix: "230"},
	{id: 121, name: "Mauritania", prefix: "222"},
	{id: 122, name: "Micronesia", prefix: "691"},
	{id: 123, name: "Moldavia", prefix: "373"},
	{id: 125, name: "Mongolia", prefix: "976"},
	{id: 126, name: "Montenegro", prefix: "382"},
	{id: 127, name: "Mozambique", prefix: "258"},
	{id: 25, name: "Myanmar", prefix: "95"},
	{id: 1, name: "México", prefix: "52"},
	{id: 124, name: "Mónaco", prefix: "377"},
	{id: 128, name: "Namibia", prefix: "264"},
	{id: 129, name: "Nauru", prefix: "674"},
	{id: 130, name: "Nepal", prefix: "977"},
	{id: 131, name: "Nicaragua", prefix: "505"},
	{id: 133, name: "Nigeria", prefix: "234"},
	{id: 134, name: "Noruega", prefix: "47"},
	{id: 135, name: "Nueva Zelanda", prefix: "64"},
	{id: 132, name: "Níger", prefix: "227"},
	{id: 136, name: "Omán", prefix: "968"},
	{id: 138, name: "Pakistán", prefix: "92"},
	{id: 139, name: "Palaos", prefix: "680"},
	{id: 140, name: "Palestina", prefix: "970"},
	{id: 141, name: "Panamá", prefix: "507"},
	{id: 142, name: "Papúa Nueva Guinea", prefix: "675"},
	{id: 143, name: "Paraguay", prefix: "595"},
	{id: 137, name: "Países Bajos", prefix: "31"},
	{id: 144, name: "Perú", prefix: "51"},
	{id: 145, name: "Polonia", prefix: "48"},
	{id: 146, name: "Portugal", prefix: "351"},
	{id: 147, name: "Reino Unido", prefix: "44"},
	{id: 39, name: "República Centroafricana", prefix: "236"},
	{id: 41, name: "República Checa", prefix: "420"},
	{id: 48, name: "República Democrática del Congo", prefix: "243"},
	{id: 57, name: "República Dominicana", prefix: "180918291849"},
	{id: 47, name: "República del Congo", prefix: "242"},
	{id: 148, name: "Ruanda", prefix: "250"},
	{id: 149, name: "Rumania/Rumanía", prefix: "40"},
	{id: 150, name: "Rusia", prefix: "7"},
	{id: 152, name: "Samoa", prefix: "685"},
	{id: 153, name: "San Cristóbal y Nieves", prefix: "1869"},
	{id: 154, name: "San Marino", prefix: "378"},
	{id: 155, name: "San Vicente y las Granadinas", prefix: "1784"},
	{id: 157, name: "Santo Tomé y Príncipe", prefix: "239"},
	{id: 158, name: "Senegal", prefix: "221"},
	{id: 159, name: "Serbia", prefix: "381"},
	{id: 160, name: "Seychelles", prefix: "248"},
	{id: 161, name: "Sierra Leona", prefix: "232"},
	{id: 162, name: "Singapur", prefix: "65"},
	{id: 163, name: "Siria", prefix: "963"},
	{id: 164, name: "Somalia", prefix: "252"},
	{id: 165, name: "Sri Lanka", prefix: "94"},
	{id: 166, name: "Suazilandia", prefix: "268"},
	{id: 167, name: "Sudáfrica", prefix: "27"},
	{id: 168, name: "Sudán", prefix: "249"},
	{id: 169, name: "Sudán del Sur", prefix: "211"},
	{id: 170, name: "Suecia", prefix: "46"},
	{id: 171, name: "Suiza", prefix: "41"},
	{id: 172, name: "Surinam", prefix: "597"},
	{id: 173, name: "Tailandia", prefix: "66"},
	{id: 174, name: "Tanzania", prefix: "255"},
	{id: 175, name: "Tayikistán", prefix: "992"},
	{id: 176, name: "Timor Oriental", prefix: "670"},
	{id: 177, name: "Togo", prefix: "228"},
	{id: 178, name: "Tonga", prefix: "676"},
	{id: 179, name: "Trinidad y Tobago", prefix: "1868"},
	{id: 181, name: "Turkmenistán", prefix: "339"},
	{id: 182, name: "Turquía", prefix: "90"},
	{id: 183, name: "Tuvalu", prefix: "688"},
	{id: 180, name: "Túnez", prefix: "216"},
	{id: 184, name: "Ucrania", prefix: "380"},
	{id: 185, name: "Uganda", prefix: "256"},
	{id: 186, name: "Uruguay", prefix: "598"},
	{id: 187, name: "Uzbekistán", prefix: "998"},
	{id: 188, name: "Vanuatu", prefix: "678"},
	{id: 190, name: "Venezuela", prefix: "58"},
	{id: 191, name: "Vietnam", prefix: "84"},
	{id: 192, name: "Yemen", prefix: "967"},
	{id: 193, name: "Yibuti", prefix: "253"},
	{id: 194, name: "Zambia", prefix: "260"},
	{id: 195, name: "Zimbabue", prefix: "263"}
]
